<div class="avatar-container">
  <div #spineContainer class="spine-container d-flex align-items-center"></div>
  <div class="loader" *ngIf="loading"></div>
</div>
